export class BookReportParam{
    rootPersonId:number|string;
    familyId:number;
}